import styled from 'styled-components'

export const DatWrapper = styled.div`
  color: #eee;
  width: 100%;
  display: grid;
  gap: 12px;
`
